import { useEffect, useState } from "react";
import api from "./api";

let cache = null;
let pending = null;

export const loadSiteInfo = (force = false) => {
  if (force || !pending) {
    pending = api.get("/environment").then(({ data }) => { cache = data; return data; }).catch(() => null);
  }
  return pending;
};

/** Public site identity: environment, version stamp and production pre-launch state. */
export function useSiteInfo() {
  const [info, setInfo] = useState(cache);
  useEffect(() => {
    let alive = true;
    loadSiteInfo().then((data) => { if (alive && data) setInfo(data); });
    return () => { alive = false; };
  }, []);
  return info;
}

export const formatEastern = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-US", {
        timeZone: "America/New_York", weekday: "short", month: "short", day: "numeric",
        year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short",
      })
    : "—";

export const formatWhen = (iso) =>
  iso ? new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—";

export const versionStamp = (info) =>
  info?.version ? `v${info.version}${info.built_at ? ` · built ${new Date(info.built_at).toLocaleDateString("en-US", { dateStyle: "medium" })}` : ""}` : "";

export async function downloadBlob(promise, fallbackName) {
  const response = await promise;
  const disposition = response.headers?.["content-disposition"] || "";
  const name = /filename="?([^";]+)"?/.exec(disposition)?.[1] || fallbackName;
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
  URL.revokeObjectURL(url);
}

export async function blobErrorDetail(error) {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try { return JSON.parse(await data.text()).detail; } catch { return "Request failed"; }
  }
  return data?.detail;
}
